import React, { useState, useEffect } from 'react';
import MacTable from '../ui/MacTable';
import '../../styles/report-modal.css';
import '../../styles/findings.css';

// Import utilities
import { getData } from '../../utils/dataUtils';
import { processContestFindings } from '../../utils/sortUtils';
import { TABLE_HEADERS } from '../../utils/constants';

const TopFindingsSection = () => {
  const [topFindings, setTopFindings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadTopFindings = async () => {
      try {
        setLoading(true);
        
        try {
          // Get data from local JSON file
          const data = getData('top-findings', { sort: 'severity', sortOrder: 'desc' });
          
          // If we got data from the audit contest JSON, we need to process it
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('contest')) {
            const processedData = processContestFindings(data);
            setTopFindings(processedData);
          } else {
            // If we got data directly from the JSON file
            setTopFindings(data);
          }
        } catch (err) {
          setError('Failed to load top findings data.');
        }
        
        setLoading(false);
      } catch (err) {
        setError('An unexpected error occurred.');
        setLoading(false);
      }
    };
    
    loadTopFindings();
  }, []);

  const renderRow = (item, index) => (
    <tr key={item.id || index}>
      <td>
        {item.title ? 
          <a href={item.findingURL} target="_blank" rel="noopener noreferrer">{item.title}</a> : 
          item.title
        }
      </td>
      <td>
        <span className={`severity ${item.severity.toLowerCase()}`}>{item.severity}</span>
      </td>
    </tr>
  );

  if (loading) {
    return (
      <section id="top-findings">
        <div className="container">
          <h2 className="topic">Top Findings</h2>
          <div className="loading">Loading top findings...</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="top-findings">
        <div className="container">
          <h2 className="topic">Top Findings</h2>
          <div className="error">{error}</div>
        </div>
      </section>
    );
  }

  return (
    <section id="top-findings">
      <div className="container">
        <h2 className="topic">Top Findings</h2>
        <MacTable
          title=""
          headers={TABLE_HEADERS.TOP_FINDINGS}
          data={topFindings}
          renderRow={renderRow}
        />
      </div>
    </section>
  );
};

export default TopFindingsSection;
